import { ContactPerson } from '../../../../../types/contactPerson'

export const clearPrimaryFlagFromContactPersons = (contacts: ContactPerson[]): ContactPerson[] => {
  return contacts.map((contact) => ({
    ...contact,
    isPrimary: false,
  }))
}
